import {JsonProperty, ObjectMapper} from "@outfoxx/jackson-js";
import {JsonParserContext} from "@outfoxx/jackson-js/dist/@types";

export class Channel {
    @JsonProperty()
    readonly id: string;
    @JsonProperty()
    needToBeChecked: boolean;
    @JsonProperty()
    readonly type: string;
    @JsonProperty()
    readonly address: string;

    constructor(type: string, address: string) {
        this.type = type;
        this.address = address;
    }

    public static createByObj(object: object | null): Channel {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        return objectMapper.parse<Channel>(JSON.stringify(object), { mainCreator: () => [Channel] } as JsonParserContext);
    }
}
